import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";
import { useTierAccess } from "../context/TierContext";
import {
  FAQ_IN_APP_ITEMS,
  FAQ_PUBLIC_ITEMS,
  type FaqItem,
} from "../data/faqContent";

/**
 * Tier-filtered FAQ items for the current user (public list when logged out).
 */
export function useFaqItems(): FaqItem[] {
  const { user } = useAuth();
  const {
    hasAIAssistant,
    hasFounderReport,
    hasAlignmentAdvantage,
    hasMonthlyConsultation,
  } = useTierAccess();

  return useMemo(() => {
    if (!user) return FAQ_PUBLIC_ITEMS;

    const access: Record<
      NonNullable<(typeof FAQ_IN_APP_ITEMS)[number]["requires"]>,
      boolean
    > = {
      hasAIAssistant,
      hasFounderReport,
      hasAlignmentAdvantage,
      hasMonthlyConsultation,
    };

    return FAQ_IN_APP_ITEMS.filter(
      (item) => !item.requires || access[item.requires]
    );
  }, [
    user,
    hasAIAssistant,
    hasFounderReport,
    hasAlignmentAdvantage,
    hasMonthlyConsultation,
  ]);
}
